var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroupMeeting(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14",
    id: "Group-Meeting-Call--Streamline-Core",
    height: 14,
    width: 14,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n    Group Meeting Call Streamline Icon: https://streamlinehq.com\n  ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "group-meeting-call--group-meeting-call-work"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3.48048 10.5327c0.63036 0 1.14136 -0.511 1.14136 -1.14133 0 -0.63036 -0.511 -1.14137 -1.14136 -1.14137 -0.63036 0 -1.14137 0.51101 -1.14137 1.14137 0 0.63033 0.51101 1.14133 1.14137 1.14133Z",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M1.42505 13.4787c0.00363 -0.348 0.09541 -0.6894 0.26675 -0.9923 0.36107 -0.6383 1.05453 -1.0436 1.78771 -1.0452 0.73318 0.0016 1.42664 0.4069 1.78771 1.0452 0.17134 0.3029 0.26311 0.6443 0.26675 0.9923",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M10.5254 10.5327c0.6304 0 1.1414 -0.511 1.1414 -1.14133 0 -0.63036 -0.511 -1.14137 -1.1414 -1.14137 -0.63036 0 -1.14137 0.51101 -1.14137 1.14137 0 0.63033 0.51101 1.14133 1.14137 1.14133Z",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8.46997 13.4787c0.00364 -0.348 0.09541 -0.6894 0.26675 -0.9923 0.36107 -0.6383 1.05453 -1.0436 1.78768 -1.0452 0.7332 0.0016 1.4267 0.4069 1.7877 1.0452 0.1714 0.3029 0.2632 0.6443 0.2668 0.9923",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M6.999 4.04708c0.58841 0 1.06541 -0.477 1.06541 -1.06541s-0.477 -1.06541 -1.06541 -1.06541 -1.06541 0.477 -1.06541 1.06541 0.477 1.06541 1.06541 1.06541Z",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M5.00781 6.71826c0.00353 -0.33741 0.09251 -0.66841 0.25864 -0.96211 0.3501 -0.61891 1.02248 -1.01193 1.73337 -1.01347 0.71089 0.00154 1.38327 0.39456 1.73337 1.01347 0.16613 0.29369 0.25512 0.6247 0.25864 0.96211",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M11.7818 0.544922H2.21823c-0.39667 0 -0.71823 0.321564 -0.71823 0.718228V6c0 0.39667 0.32156 0.71823 0.71823 0.71823h9.56357c0.3966 0 0.7182 -0.32156 0.7182 -0.71823V1.26315c0 -0.396664 -0.3216 -0.718228 -0.7182 -0.718228Z",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupMeeting);
export default __webpack_public_path__ + "static/media/Group-Meeting.02eaeba3e51977a681c441d2861c892b.svg";
export { ForwardRef as ReactComponent };